// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutBlank_wrapper__11syr"};